import {
  Avatar,
  List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText,
  MenuItem, Select,
} from '@material-ui/core';
import { Language, House } from '@material-ui/icons';
import { map, filter, includes } from 'lodash';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguagePref, getLanguagePref, getLanguagesByCountry } from '../../../utilities/language';
import { getCurrentWarehouse } from '../../../utilities/common';
import { setDefaultWarehouse,getDefaultWarehouse } from '../../../actions/userManagementActions';
import { useDispatch, useSelector } from 'react-redux'
import { useToken } from '../../../utilities/hooks';

function SystemSettings() {
  const warehouses = useSelector(state => state.common.branches);
  const dispatch = useDispatch();
  const tokenContents = useToken();
  const allValidWarehouses = tokenContents.warehouse;
  const userUS = tokenContents.userUS;
  const userId = localStorage.getItem('user_id');
  const defaultwarehouse = useSelector(state => state.userManagementReducer.getDefaultWarehouse)
  const { t, i18n } = useTranslation();
  const languagePref = getLanguagePref();
  const [selectedLanguage, setSelectedLanguage] = useState(languagePref);
  const [finalWarehouses, setFinalWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(defaultwarehouse);

  // US-BRANCH-OFF
  const languages = getLanguagesByCountry(userUS?'us':'');
  
  useEffect(() => {
    try{
      dispatch(getDefaultWarehouse(userId));
    } catch(error){
      console.log("Failed to retrieve data from server.");
    }


    setFinalWarehouses(getValidWarehouses());
  }, []);

  useEffect(() => {
    setSelectedWarehouse(defaultwarehouse);
  }, [defaultwarehouse]);

  function getValidWarehouses() {
    return filter(warehouses, (o) => includes(allValidWarehouses, Number(o.id)));
  }


  function handleLanguageChange(event) {
    changeLanguagePref(i18n, event.target.value);
    setSelectedLanguage(event.target.value);
  }

  function handleWarehouseChange(event) {
    const updateWarehouse = event.target.value;
    dispatch(setDefaultWarehouse(userId, updateWarehouse));
    setSelectedWarehouse(event.target.value);
  }
  return (
    <div>
      <List>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <Language />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={t('common:language')}
          />
          <ListItemSecondaryAction>
            <Select
              value={selectedLanguage}
              onChange={handleLanguageChange}
            >
              {
                map(languages, (language, index) => (
                  <MenuItem
                    key={`language-menu-${index}`}
                    value={language.value}
                  >
                    {language.display_name}
                  </MenuItem>
                ))
              }
            </Select>
          </ListItemSecondaryAction>
        </ListItem>

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <House />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={t('common:default_warehouse')}
          />
          <ListItemSecondaryAction>
            <Select
              displayEmpty = {true}
              value={selectedWarehouse}
              onChange={handleWarehouseChange}
            >
              {
                map(finalWarehouses, (wares, index) => (
                  <MenuItem
                    key={`warehouse-menu-${index}`}
                    value={wares.id}
                  >
                    {wares.name}
                  </MenuItem>
                ))
              }
            </Select>
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    </div>
  )
}

export default SystemSettings